module.exports = __webpack_public_path__ + "img/watermark.1dace6fe.png";